"use client"

import React from "react"
import { ImageProps } from "next/image"
import { ImageRO } from "@ub/product-client"

import ImageWithFallback from "@/components/storyblok/common/ImageWithFallback"

interface ImageWithBadgeProps {
  src: string
  alt?: string
  badgeText: string | number
}

export default function ImageWithBadge({ src, alt, badgeText, ...restProps }: ImageWithBadgeProps & ImageProps) {
  return (
    <div className="relative flex size-24 flex-none items-center justify-center overflow-visible rounded-sm border">
      <ImageWithFallback src={src ?? ""} alt={alt ?? ""} {...restProps} />
      <div
        className="
          absolute -right-2 -bottom-2 flex h-5 w-auto items-center justify-center rounded-full border bg-white px-2.5
          py-0.5 text-xs text-gray-800 shadow-sm
        "
      >
        <strong>{badgeText}</strong>
      </div>
    </div>
  )
}
